module.exports = __webpack_public_path__ + "img/personal_settings.e998f96f.svg";